import PropTypes from "prop-types";

import { Link, Paper, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";

import {
  formatDate,
  formatNumber,
  getShortReference,
  getTransactionPath,
} from "@/features/shared";

export const SalesInvoicePaymentsSection = ({ salesInvoicePayments }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Stack spacing={2}>
        <Typography variant="subtitle1">Pembayaran Faktur Penjualan</Typography>
        <DataGrid
          rows={salesInvoicePayments}
          getRowHeight={() => "auto"}
          columns={[
            {
              field: "salesInvoice",
              headerName: "Faktur #",
              flex: 2,
              sortable: false,
              renderCell: ({ row }) => {
                const path = getTransactionPath(
                  row.salesInvoice.referenceNumber
                );
                const shortRef = getShortReference(
                  row.salesInvoice.referenceNumber
                );

                return (
                  <Stack>
                    <Link
                      component={RouterLink}
                      to={path}
                      underline="hover"
                      sx={{ fontWeight: 500 }}
                    >
                      {shortRef}
                    </Link>
                    <Typography variant="caption" sx={{
                      color: "text.secondary"
                    }}>
                      {row.salesInvoice.buyerReferenceNumber || "-"}
                    </Typography>
                  </Stack>
                );
              },
            },
            {
              field: "transactionDate",
              headerName: "Tanggal",
              flex: 1,
              sortable: false,
              valueGetter: (_, row) =>
                formatDate(row.salesInvoice.transactionDate),
            },
            {
              field: "grandTotal",
              headerName: "Total Faktur",
              flex: 1,
              type: "number",
              sortable: false,
              valueGetter: (_, row) =>
                formatNumber(row.salesInvoice.grandTotal),
            },
            {
              field: "outstandingAmount",
              headerName: "Terutang",
              flex: 1,
              type: "number",
              sortable: false,
              valueGetter: (value) => formatNumber(value),
            },
            {
              field: "allocatedAmount",
              headerName: "Terima",
              flex: 1,
              type: "number",
              sortable: false,
              valueGetter: (value) => formatNumber(value),
            },
            {
              field: "discount",
              headerName: "Diskon",
              flex: 1,
              type: "number",
              sortable: false,
              valueGetter: (value) => formatNumber(value),
            },
          ]}
          hideFooter
          disableRowSelectionOnClick
        />
      </Stack>
    </Paper>
  );
};

SalesInvoicePaymentsSection.propTypes = {
  salesInvoicePayments: PropTypes.arrayOf(PropTypes.object).isRequired,
};
